import React, { PropTypes } from 'react';
import DraftProjects from 'your_projects/containers/draft_projects';
import PostedProjects from 'your_projects/containers/posted_projects';
import WatchlistProjects from 'your_projects/containers/watchlist_projects';

const CONTENT_MAP = {
  client: {
    drafts: DraftProjects,
    active: PostedProjects,
    wrapup: PostedProjects,
    complete: PostedProjects
  },
  creative: {
    watchlist: WatchlistProjects,
    participating: PostedProjects,
    wrapup: PostedProjects,
    awarded: PostedProjects,
    history: PostedProjects,
  }
};

const Projects = ({ items, userType, projectType }) => {
  const Content = CONTENT_MAP[userType][projectType];

  return <Content items={items} />;
}

Projects.propTypes = {
  items: PropTypes.array.isRequired,
  userType: PropTypes.string.isRequired,
  projectType: PropTypes.string.isRequired,
};

export default Projects;



// WEBPACK FOOTER //
// ./your_projects/components/projects.jsx